import { useState, useEffect } from "react";
import { useGenericAPI } from "./useGenericAPI";

export const useTherapist = () => {
  const { getRequest, loading, data } = useGenericAPI("/therapists");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [currentFilters, setCurrentFilters] = useState({});

  useEffect(() => {
    const params = new URLSearchParams();
    
    if (currentFilters.name_therapist) {
      params.append('name', currentFilters.name_therapist);
    }

    params.append('page', currentPage);
    params.append('per_page', perPage);
    
    const queryString = params.toString() ? `?${params.toString()}` : '';
    getRequest(queryString);
  }, [currentPage, perPage, currentFilters, getRequest]);

  const therapists = data?.items || [];
  const pageCount = data?.pagination?.total_pages || 0;
  const totalTherapists = data?.pagination?.total_count || 0;

  const handleFilterSubmit = (filters) => {
    setCurrentFilters(filters);
    setCurrentPage(1);
  };

  const handlePageChange = (event) => {
    setCurrentPage(event.selected + 1);
  };

  const handlePerPageChange = (event) => {
    setPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  return {
    therapists,
    loading,
    totalTherapists,
    pageCount,
    currentPage,
    perPage,
    handleFilterSubmit,
    handlePageChange,
    handlePerPageChange,
  };
};
